/*
  Santísimas Órbita
  Tema privado y exclusivo de Santísimas Ropa Íntima.
  Uso autorizado: Santísimas Colombia y Santísimas USA.
  No distribuir, revender ni reutilizar fuera de la marca sin autorización escrita.
*/

document.documentElement.classList.remove('no-js');

class SantisimasTheme {
  constructor() {
    this.header = document.querySelector('[data-site-header]');
    this.menuButton = document.querySelector('[data-menu-toggle]');
    this.mobileMenu = document.querySelector('[data-mobile-menu]');
    this.bindEvents();
    this.observeReveals();
    this.updateHeader();
  }

  bindEvents() {
    window.addEventListener('scroll', () => this.updateHeader(), { passive: true });

    if (this.menuButton && this.mobileMenu) {
      this.menuButton.addEventListener('click', () => this.toggleMenu());
      this.mobileMenu.querySelectorAll('a').forEach((link) => {
        link.addEventListener('click', () => this.closeMenu());
      });
    }

    document.addEventListener('keyup', (event) => {
      if (event.key === 'Escape') this.closeMenu();
    });
  }

  updateHeader() {
    if (!this.header) return;
    this.header.classList.toggle('is-scrolled', window.scrollY > 24);
  }

  toggleMenu() {
    const open = !document.body.classList.contains('menu-open');
    document.body.classList.toggle('menu-open', open);
    this.menuButton.setAttribute('aria-expanded', String(open));
    this.mobileMenu.hidden = !open;
  }

  closeMenu() {
    if (!this.menuButton || !this.mobileMenu) return;
    document.body.classList.remove('menu-open');
    this.menuButton.setAttribute('aria-expanded', 'false');
    this.mobileMenu.hidden = true;
  }

  observeReveals() {
    const elements = document.querySelectorAll('[data-reveal]');
    if (!elements.length) return;

    if (!('IntersectionObserver' in window)) {
      elements.forEach((element) => element.classList.add('is-visible'));
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.14 }
    );

    elements.forEach((element) => observer.observe(element));
  }
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube:not([data-ignore-pause])').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
  });

  document.querySelectorAll('.js-vimeo:not([data-ignore-pause])').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });

  document.querySelectorAll('video:not([data-ignore-pause])').forEach((video) => {
    video.pause();
  });

  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function initProductCardSecondaryImages() {
  const loadSecondaryImage = (card) => {
    const template = card.querySelector('[data-product-secondary-image-template]');
    if (!template) return;

    template.replaceWith(template.content.cloneNode(true));
  };

  document.addEventListener('mouseover', (event) => {
    const card = event.target.closest?.('.product-card__media');
    if (card) loadSecondaryImage(card);
  }, { passive: true });

  document.addEventListener('pointerover', (event) => {
    const card = event.target.closest?.('.product-card__media');
    if (card) loadSecondaryImage(card);
  }, { passive: true });

  document.addEventListener('focusin', (event) => {
    const card = event.target.closest?.('.product-card__media');
    if (card) loadSecondaryImage(card);
  });

  document.addEventListener('touchstart', (event) => {
    const card = event.target.closest?.('.product-card__media');
    if (card) loadSecondaryImage(card);
  }, { passive: true });
}

class OrbitaDeferredMedia extends HTMLElement {
  constructor() {
    super();

    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;

    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    pauseAllMedia();

    if (this.getAttribute('loaded')) return;

    const template = this.querySelector('template');
    if (!template) return;

    const content = document.createElement('div');
    content.appendChild(template.content.firstElementChild.cloneNode(true));

    this.setAttribute('loaded', true);
    const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));

    if (focus && deferredElement) deferredElement.focus();
    if (deferredElement?.nodeName === 'VIDEO' && deferredElement.getAttribute('autoplay')) {
      deferredElement.play();
    }
  }
}

if (!customElements.get('deferred-media')) {
  customElements.define('deferred-media', OrbitaDeferredMedia);
}

class OrbitaCartDrawer {
  constructor() {
    this.drawer = document.querySelector('[data-orbita-cart-drawer]');
    if (!this.drawer) return;

    this.itemsContainer = this.drawer.querySelector('[data-orbita-cart-items]');
    this.subtotalElement = this.drawer.querySelector('[data-orbita-cart-subtotal]');
    this.focusedElement = null;
    this.bindEvents();
  }

  bindEvents() {
    document.addEventListener('click', (event) => {
      const openButton = event.target.closest('[data-orbita-cart-open]');
      if (openButton && this.drawer) {
        event.preventDefault();
        this.open(openButton);
        return;
      }

      if (event.target.closest('[data-orbita-cart-close]')) {
        event.preventDefault();
        this.close();
        return;
      }

      const removeButton = event.target.closest('[data-orbita-cart-remove]');
      if (removeButton) {
        event.preventDefault();
        this.removeItem(removeButton.dataset.orbitaCartRemove);
      }
    });

    document.addEventListener('submit', (event) => {
      const form = event.target;
      if (!this.shouldHandleProductForm(form, event.submitter)) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      this.addFromForm(form, event.submitter);
    }, true);

    document.addEventListener('keyup', (event) => {
      if (event.key === 'Escape') this.close();
    });
  }

  shouldHandleProductForm(form, submitter) {
    if (!(form instanceof HTMLFormElement)) return false;
    const action = form.getAttribute('action') || '';
    const isAddToCart = action.includes('/cart/add');
    if (!isAddToCart) return false;
    if (submitter && submitter.name && submitter.name !== 'add') return false;
    return form.querySelector('[name="id"]');
  }

  async addFromForm(form, submitter) {
    this.setButtonLoading(submitter, true);

    try {
      const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: new FormData(form),
      });

      const data = await response.json();
      if (!response.ok || data.status) {
        throw new Error(data.description || data.message || 'No se pudo agregar el producto.');
      }

      const cart = await this.fetchCart();
      this.renderCart(cart);
      this.open(submitter || form);
    } catch (error) {
      this.showFormError(form, error.message);
    } finally {
      this.setButtonLoading(submitter, false);
    }
  }

  async removeItem(key) {
    if (!key) return;

    await fetch(`${window.Shopify?.routes?.root || '/'}cart/change.js`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ id: key, quantity: 0 }),
    });

    const cart = await this.fetchCart();
    this.renderCart(cart);
  }

  async fetchCart() {
    const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, {
      headers: { Accept: 'application/json' },
    });
    return response.json();
  }

  renderCart(cart) {
    if (!this.itemsContainer || !this.subtotalElement) return;

    this.updateCounts(cart.item_count);
    this.drawer.classList.toggle('is-empty', cart.item_count === 0);
    this.subtotalElement.textContent = this.formatMoney(cart.total_price);

    if (!cart.items.length) {
      this.itemsContainer.innerHTML = `
        <div class="orbita-cart-drawer__empty">
          <p>Tu bolsa está vacía</p>
          <a class="button button--solid orbita-cart-drawer__continue" href="/collections/all">Continuar comprando</a>
        </div>
      `;
      return;
    }

    this.itemsContainer.innerHTML = cart.items.map((item) => this.renderItem(item)).join('');
  }

  renderItem(item) {
    const image = item.image
      ? `<a class="orbita-cart-item__image" href="${item.url}"><img src="${item.image}" alt="${this.escapeHtml(item.product_title)}" loading="lazy"></a>`
      : `<a class="orbita-cart-item__image" href="${item.url}"></a>`;
    const variant = item.variant_title && item.variant_title !== 'Default Title'
      ? `<p class="orbita-cart-item__variant">${this.escapeHtml(item.variant_title)}</p>`
      : '';

    return `
      <article class="orbita-cart-item" data-orbita-cart-item-key="${this.escapeHtml(item.key)}">
        ${image}
        <div class="orbita-cart-item__content">
          <a class="orbita-cart-item__title" href="${item.url}">${this.escapeHtml(item.product_title)}</a>
          ${variant}
          <div class="orbita-cart-item__meta">
            <span>Cantidad: ${item.quantity}</span>
            <span>${this.formatMoney(item.final_line_price)}</span>
          </div>
          <button class="orbita-cart-item__remove" type="button" data-orbita-cart-remove="${this.escapeHtml(item.key)}">Eliminar</button>
        </div>
      </article>
    `;
  }

  updateCounts(count) {
    document.querySelectorAll('[data-orbita-cart-count]').forEach((element) => {
      element.textContent = count;
      element.classList.toggle('is-hidden', count === 0);
    });

    document.querySelectorAll('[data-orbita-cart-open]').forEach((element) => {
      element.setAttribute('aria-label', `Bolsa, ${count} artículos`);
    });
  }

  open(triggeredBy) {
    this.focusedElement = triggeredBy || document.activeElement;
    this.drawer.classList.add('is-open');
    this.drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('orbita-cart-open');
    this.drawer.querySelector('[data-orbita-cart-close]')?.focus();
  }

  close() {
    this.drawer.classList.remove('is-open');
    this.drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('orbita-cart-open');
    if (this.focusedElement && document.contains(this.focusedElement)) {
      this.focusedElement.focus();
    }
  }

  setButtonLoading(button, loading) {
    if (!button) return;
    button.toggleAttribute('aria-disabled', loading);
    button.classList.toggle('loading', loading);
    button.disabled = loading;
    button.querySelector('.loading__spinner')?.classList.toggle('hidden', !loading);
  }

  showFormError(form, message) {
    const wrapper = form.closest('product-form')?.querySelector('.product-form__error-message-wrapper');
    const text = wrapper?.querySelector('.product-form__error-message');
    if (wrapper && text) {
      text.textContent = message;
      wrapper.hidden = false;
      return;
    }
    window.alert(message);
  }

  formatMoney(cents) {
    const currency = window.Shopify?.currency?.active || 'COP';
    return (Number(cents || 0) / 100).toLocaleString('es-CO', {
      style: 'currency',
      currency,
      maximumFractionDigits: 0,
    });
  }

  escapeHtml(value) {
    return String(value || '').replace(/[&<>"']/g, (character) => ({
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      '"': '&quot;',
      "'": '&#39;',
    }[character]));
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new SantisimasTheme();
  new OrbitaCartDrawer();
  initProductCardSecondaryImages();
});
